import { useTranslation } from "react-i18next"
import { Link } from "../navigation";

import { Comment } from "../comments/Comments";
import { commodity } from "../data";
import { useComments, Comment as CommentProps } from "../comments/CommentsProvider";
import { useRoles } from "../user/Auth";

export default function ProductComments({ commodityId, name }: {
    commodityId: number;
    name: string;
}) {
    const { t } = useTranslation()
    const { isEditUser } = useRoles()
    const { commentsLookUp } = useComments()

    const comments: CommentProps[] = commentsLookUp[commodity]?.[commodityId] ?? []

    const addButtonStyle = 'btn-secondary bg-white text-sm whitespace-nowrap min-w-fit py-0.5'

    return (
        <div>
            <div className="flex flex-row pb-4 px-1">
                <h3 className="grow">{t('comments')}</h3>
                {isEditUser && (
                    <Link title={t('add-comment')} to={`comments?entity=${commodity}&entityId=${commodityId}&name=${name}`} className={addButtonStyle}>
                        {t('add')}
                    </Link>
                )}
            </div>
            <div className="space-y-3">
                {comments.map((c, ci) => (
                    <Comment key={ci} {...c} />
                ))}
            </div>
        </div>
    )
}

